// form fixes
const observer = new MutationObserver(() => {
    const label = document.querySelector('form.g-container label[tabindex="0"]');
    if (label) {
        label.removeAttribute('tabindex');
    }

    const removeBtn = document.querySelector('div[data-file-remove]');
    if (removeBtn) {
        removeBtn.setAttribute('tabindex', '0');
        removeBtn.setAttribute('role', 'button'); // for screen readers

        // Allow Enter/Space to activate it
        removeBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                removeBtn.click();   // simulate click, triggers plugin removal
                document.querySelector('.gfb__dropzone--placeholder--button').focus();
            }
        });            
    }
});
observer.observe(document.body, { childList: true, subtree: true });

// mp4 playback toggle button
document.addEventListener('DOMContentLoaded', () => {
    const origin = document.querySelector('.hero__media-container');
    if(origin){
        const video = origin.parentElement.parentElement.querySelector('video');
        const btn = document.querySelector('div.video-playback-toggle button');
        if (btn, video) {
            btn.addEventListener('click', () => {
                // console.log('toggle play/pause')
                if (video.paused) {
                    video.play();
                    btn.className = "video-playback-toggle--pause";
                }
                else {
                    video.pause();            
                    btn.className = "video-playback-toggle--play";
                }

                video.controls = false;
            });
        }
    }
    
});

// Cart remove buttons (high-31): handle navigation for button[data-url] in .cart__remove
document.addEventListener('click', function(e) {
  var btn = e.target.closest('.cart__remove button[data-url]');
  if (!btn) return;
  window.location.href = btn.dataset.url;
});

// Product grid image keyboard navigation
// Arrow right/left cycle through primary/secondary images; focus never auto-swaps the image.
(function() {
    var liveRegion = document.createElement('div');
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.className = 'visually-hidden';
    document.body.appendChild(liveRegion);

    function announceImageAlt(mask, showSecondary) {
        var img;
        if (showSecondary) {
            img = mask.querySelector('.grid-product__secondary-image img');
        } else {
            var secondaryContainer = mask.querySelector('.grid-product__secondary-image');
            img = Array.prototype.find.call(
                mask.querySelectorAll('img'),
                function(el) { return !secondaryContainer || !secondaryContainer.contains(el); }
            );
        }
        liveRegion.textContent = (img && img.alt) ? img.alt : '';
    }

    document.addEventListener('keydown', function(e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        if (!e.target.querySelector('.grid-product__secondary-image')) return;
        e.preventDefault();
        var showSecondary = e.key === 'ArrowRight';
        e.target.classList.toggle('pbk-image-active', showSecondary);
        announceImageAlt(e.target, showSecondary);
    });

    document.addEventListener('focusin', function(e) {
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        announceImageAlt(e.target, false);
    });

    document.addEventListener('focusout', function(e) {
        if (!e.target.matches('.grid-product__image-mask[tabindex]')) return;
        e.target.classList.remove('pbk-image-active');
        liveRegion.textContent = '';
    });
}());

// a11y debug, highlight currently tabbed element
// (function () {
//     let last;

//     document.addEventListener("focusin", e => {
//         // Remove outline from previously focused element
//         if (last) last.style.outline = "";

//         // Add outline to new focused element
//         e.target.style.outline = "3px solid red";
//         last = e.target;
//     });
// })();